import styled from "styled-components";

export const Cards = styled.div`
display: flex;
flex-wrap: wrap;
gap:20px;
justify-content: center;
`